import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _slicedToArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { IconButton, makeStyles, Modal, Typography, Divider, Button, List, ListItem, ListItemText, CircularProgress } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import FileDownload from "js-file-download";
import samples from '../dal/samples';
import { format } from 'date-fns';
import { useSnackbar } from 'notistack';
var styles = makeStyles(function () {
  return {
    listContainer: {
      margin: '16px 0',
      maxHeight: 250,
      overflowY: 'auto',
      borderRadius: 4
    },
    modalRoot: {
      // display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center',
      display: "flex",
      // width: "460px",
      padding: "24px",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "24px"
    },
    modalBackdrop: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: "5px",
      alignSelf: 'stretch',
      marginBottom: '24px'
    },
    modalTitle: {
      fontWeight: 600,
      fontFamily: 'Roboto',
      fontSize: '20px',
      color: '#3F3F3F'
    },
    subHead: {
      fontFamily: 'Roboto',
      fontSize: '16px',
      fontWeight: 400,
      color: '#3F3F3F'
    },
    modalContent: {
      position: 'relative',
      background: '#fff',
      padding: '1.5rem 1.5rem 1.5rem 1.5rem',
      borderRadius: 8,
      maxWidth: '600px',
      width: '460px',
      outline: 'none'
    },
    listItem: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "4px",
      paddingLeft: 0
    },
    listItemText: {
      color: "#3F3F3F",
      fontFamily: "Roboto",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      margin: 0
    },
    subText: {
      color: "#9F9F9F",
      fontFamily: "Roboto",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      margin: 0
    },
    cancelButton: {
      padding: "5px 16px",
      float: 'right',
      borderRadius: "4px",
      border: "1px solid #2EA8DF",
      background: "#FFF",
      color: '#2EA8DF',
      fontFamily: 'Roboto',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      marginTop: '15px',
      "&:hover": {
        border: "1px solid #2EA8DF",
        background: "#FFF",
        color: '#2EA8DF'
      }
    },
    closeButton: {
      position: 'absolute',
      top: 8,
      right: 8
    }
  };
});
var ReportDownloadPopup = function ReportDownloadPopup(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    sampleId = _ref.sampleId,
    institutionCode = _ref.institutionCode,
    testName = _ref.testName;
  var classes = styles();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    downloadingFile = _useState4[0],
    setDownloadingFile = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    reportData = _useState6[0],
    setReportData = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var _useSnackbar = useSnackbar(),
    enqueueSnackbar = _useSnackbar.enqueueSnackbar;
  var fetchReports = function fetchReports() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var reports;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return samples.getReportList(sampleId);
            case 4:
              reports = _context.sent;
              setReportData(reports);
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              setError(_context.t0.message || 'Error fetching reports');
            case 11:
              _context.prev = 11;
              setLoading(false);
              return _context.finish(11);
            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8, 11, 14]]);
    }));
  };
  useEffect(function () {
    if (!isOpen) return;
    setLoading(true);
    setError(null);
    setReportData(null);
    fetchReports();
  }, [isOpen, sampleId]);
  var handleDownload = function handleDownload(sampleId, fileName) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var patientOrderRes, patientOrder, filename, labNumber, accessionNumber, blob, errorMessage, message;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setDownloadingFile(fileName);
              _context2.prev = 1;
              _context2.next = 4;
              return samples.getSampleByIdv2(institutionCode, sampleId);
            case 4:
              patientOrderRes = _context2.sent;
              patientOrder = patientOrderRes.data;
              if (!(sampleId && institutionCode)) {
                _context2.next = 23;
                break;
              }
              filename = "".concat(reportData && reportData.testName, "-").concat(fileName.split(".pdf")[0], "-report.pdf");
              if (window.appConfig.customReportNameHospitalCodes.includes(institutionCode)) {
                labNumber = patientOrder.labNumber;
                accessionNumber = patientOrder.accessionNumber;
                filename = accessionNumber ? "".concat(labNumber, "-").concat(accessionNumber, ".pdf") : "".concat(labNumber, ".pdf");
              }
              _context2.prev = 9;
              _context2.next = 12;
              return samples.downloadReport({
                items: [{
                  sampleId: sampleId,
                  filename: fileName
                }]
              });
            case 12:
              blob = _context2.sent;
              FileDownload(blob, filename);
              enqueueSnackbar("Downloaded ".concat(filename), {
                variant: "success"
              });
              _context2.next = 23;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](9);
              errorMessage = "";
              if (_context2.t0 instanceof Error) errorMessage = ": ".concat(_context2.t0.message);
              message = "There was a problem downloading ".concat(filename).concat(errorMessage);
              enqueueSnackbar(message, {
                variant: "error"
              });
            case 23:
              _context2.prev = 23;
              setDownloadingFile(null);
              return _context2.finish(23);
            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1,, 23, 26], [9, 17]]);
    }));
  };
  var formatDate = function formatDate(date) {
    if (date) {
      var reportedDate = new Date(date);
      return format(reportedDate, "MM/dd/yyyy");
    }
    return "";
  };
  return React.createElement(Modal, {
    open: isOpen,
    onClose: onClose,
    className: classes.modalRoot,
    BackdropProps: {
      className: classes.modalBackdrop
    }
  }, React.createElement("div", {
    className: classes.modalContent
  }, React.createElement(IconButton, {
    className: classes.closeButton,
    onClick: onClose,
    "aria-label": "Close"
  }, React.createElement(Close, null)), React.createElement("div", {
    className: classes.header
  }, React.createElement(Typography, {
    className: classes.modalTitle
  }, "Download Report PDF"), React.createElement(Typography, {
    className: classes.subHead
  }, "Click the report you want to download")), React.createElement(Divider, {
    style: {
      margin: '16px 0'
    }
  }), React.createElement("div", {
    className: classes.listContainer
  }, loading ? React.createElement("div", {
    style: {
      textAlign: 'center',
      padding: 24
    }
  }, React.createElement(CircularProgress, {
    size: 32
  })) : error ? React.createElement(Typography, {
    style: {
      padding: "16px 16px 16px 0px"
    }
  }, "There was an error loading reports. Please try again later.") : reportData && reportData.reportLinks && reportData.reportLinks.length === 0 ? React.createElement(Typography, {
    style: {
      padding: 16
    }
  }, "No reports available.") : React.createElement(List, null, reportData && reportData.reportLinks.map(function (report) {
    return React.createElement(ListItem, {
      button: true,
      className: classes.listItem,
      key: report.reportPath,
      onClick: function onClick() {
        return handleDownload(sampleId, report.fileName);
      },
      disabled: !!downloadingFile
    }, React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        width: '100%'
      }
    }, React.createElement(ListItemText, {
      className: classes.listItemText,
      primary: reportData.testName ? reportData.testName + " - " + report.fileName : report.fileName
    }), downloadingFile === report.fileName && React.createElement(CircularProgress, {
      size: 32
    })), React.createElement("p", {
      className: classes.subText
    }, "Reported ", formatDate(report.whenArchived)));
  }))), React.createElement(Divider, {
    style: {
      margin: '16px 0'
    }
  }), React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    onClick: onClose,
    className: classes.cancelButton
  }, "Cancel")));
};
import { SnackbarProvider } from 'notistack';
var ReportDownloadPopupWithSnackbar = function ReportDownloadPopupWithSnackbar(props) {
  return React.createElement(SnackbarProvider, {
    maxSnack: 3,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    }
  }, React.createElement(ReportDownloadPopup, Object.assign({}, props)));
};
export default ReportDownloadPopupWithSnackbar;